import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import {darken, lighten} from "@mui/material/styles";

const useConnectStyles = makeStyles((theme: Theme) =>
  createStyles({
    listOption: {
      fontSize: "14px",
    },
    groupHeader: {
      textTransform: "uppercase",
      fontFamily: "cera-pro-bold",
      color: theme.palette.primary.main,
      fontSize: "16px",
    },
    chip: {
      borderRadius: "6px",
      margin: "8px",
    },
    cardHeader: {
      fontFamily: "cera-pro-bold",
      textTransform: "uppercase",
    },
    textBox: {
      borderRadius: "4px",
    },
    rowDiv: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    selectionPanel: {
      background: theme.palette.mode == 'dark' ? lighten(theme.palette.background.paper, 0.14) : darken(theme.palette.background.paper, 0.06),
      minHeight: "60px",
    },
    selectionText: {
      paddingLeft: "12px",
      paddingTop: "10px",
      color: theme.palette.text.primary,
      fontSize: "0.75rem",
      lineHeight: "1",
    },
    selectionCount: {
      textAlign: "right",
      paddingRight: "12px",
      paddingTop: "10px",
      color: theme.palette.text.primary,
      fontSize: "0.75rem",
      lineHeight: "1",
    },
  })
);

export default useConnectStyles;
